

























import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class MainHead extends Vue {
  /**
   * title 标题名称
   * src 图片地址
   * btn 按钮状态
   * btnText1 文字1
   * btnText2 文字2
   */
  @Prop({ default: '' }) title!: string
  @Prop() src!: string
  @Prop() btn!: (string | boolean)
  @Prop() btnText1!: string
  @Prop() btnText2!: string
  @Prop({ default: '' }) content!: string[]
}
